// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Common imports
const SocialProviderButton = require('client-v2/common/components/social-provider-button')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('AuthModal')

class AuthModal extends React.PureComponent {
  constructor(props) {
    super(props)

    // Ensure function references do not change between render calls
    this.onHasAccountToggle = this.onHasAccountToggle.bind(this)
    this.onSocialProviderClick = this.onSocialProviderClick.bind(this)
  }

  // Event handler methods

  onClose() {
    this.props.onClose()
  }

  onHasAccountToggle() {
    const toggled = !this.props.hasAccount
    this.props.onHasAccountToggle(toggled)
  }

  onSocialProviderClick(event) {
    const { provider } = event.currentTarget.dataset
    this.props.onSocialProviderAuth(provider)
  }

  // Render methods

  render() {
    if (!this.props.isVisible) {
      return null
    }
    return (
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        this.renderBackdrop(),
        this.renderContent(),
        this.renderCloseButton()
      )
    )
  }

  renderBackdrop() {
    return (
      tag('div', {
        className: bem.element('backdrop'),
        onClick: this.props.onClose
      })
    )
  }

  renderContent() {
    return (
      tag('div', {
        className: bem.element('content')
      },
        tag('div', {
          className: bem.element('stack')
        },
          this.renderCaption(),
          this.renderHeadline(),
          this.renderSocialButtons(),
          this.renderTermsOfService(),
          this.renderHasAccountToggle()
        )
      )
    )
  }

  renderCloseButton() {
    return (
      tag('button', {
        className: bem.element('close-button'),
        onClick: this.props.onClose
      })
    )
  }

  renderCaption() {
    return (
      tag('div', {
        className: bem.element('top-text')
      },
        this.props.hasAccount
        ? `Welcome back to Mix!`
        : `Let's get you set up`
      )
    )
  }

  renderHeadline() {
    return (
      tag('div', {
        className: bem.element('headline')
      },
        this.props.hasAccount
        ? `Sign in below:`
        : `Select one to create your Mix account.`
      )
    )
  }

  renderSocialButtons() {
    return tag('div', {
      className: bem.element('buttons-container')
    },
      this.props.socialProviders.map(provider => {
        if (
          // Hide certain providers based on login or signup prompt
          provider.hasAccount != null &&
          provider.hasAccount !== this.props.hasAccount
        ) {
          return null
        }
        return tag(SocialProviderButton, {
          key: provider.id,
          className: bem.element('button'),
          providerId: provider.id,
          providerName: provider.name,
          onClick: this.onSocialProviderClick
        })
      })
    )
  }

  renderTermsOfService() {
    if (this.props.hasAccount) {
      return null
    }
    return (
      tag('div', {
        className: bem.element('bottom-text')
      },
        `By continuing you agree to Mix's `,
        tag('a', {
          className: bem.element('bottom-href'),
          href: '/tos'
        },
          `Terms of Service`
        ),
        `, `,
        tag('a', {
          className: bem.element('bottom-href'),
          href: '/privacy'
        },
          `Privacy Policy`
        ),
        `.`
      )
    )
  }

  renderHasAccountToggle() {
    const { hasAccount } = this.props
    return (
      tag('div', {
        className: bem.element('bottom-text', {
          'sign-in': hasAccount,
          'sign-up': !hasAccount
        })
      },
        (hasAccount
          ? `Don't have a Mix account?`
          : `Already have a Mix account?`
        ),
        ` `,
        tag('a', {
          className: bem.element('bottom-href'),
          onClick: this.onHasAccountToggle
        },
          (hasAccount
            ? 'Sign up'
            : 'Sign in'
          )
        ),
        `.`
      )
    )
  }
}

AuthModal.propTypes = {
  // Flags
  isVisible: PropTypes.bool,
  hasAccount: PropTypes.bool,
  // Values
  className: PropTypes.string,
  socialProviders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    hasAccount: PropTypes.bool
  })).isRequired,
  // Callbacks
  onClose: PropTypes.func.isRequired,
  onHasAccountToggle: PropTypes.func.isRequired,
  onSocialProviderAuth: PropTypes.func.isRequired
}

module.exports = AuthModal
